export const WISHLIST = '/wishlist';

export const SIZE_OF_WISHLIST_TO_BE_FETCHED = 12;

export const IO_OPTIONS = { rootMargin: '-60px' };

export const MIN_NUMBER_OF_PRODUCTS_TO_SHOW_PRODUCT_COUNT = 4;
